import { List } from 'antd';
import styled from 'styled-components';

export const TabItem = styled(List.Item)`
  cursor: pointer;
  &:hover {
    background-color: #fdfdfd;
    h5 {
      color: ${(props) => props.theme.antd?.colorTextHeading};
    }
  }
`;

export const TabItemTitle = styled.h5`
  margin: 0;
  line-height: 24px;
  font-size: 14px;
  color: ${(props) => props.theme.antd?.colorTextSecondary};
  font-weight: 500;
`;

export const TabItemContent = styled.p`
  margin: 0;
  line-height: 22px;
  font-size: 14px;
  color: ${(props) => props.theme.antd?.colorPrimary};
`;
